import { useEffect, useState } from "react";
import genericStyles from "../../Styles/genericStyles.module.css";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import CourseForm from "./CourseForm";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Button,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { CourseModel, CourseState, ProductsModel } from "../../Utils/Models";
import Config from "../../Utils/Config";
import { useLocation, useNavigate } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { AxiosResponse } from "axios";
import { getData } from "../../Services/getData";
import { Delete, Edit } from "@mui/icons-material";
import GenericModal from "../GenericModal";
import StandardActionButtons from "../StandarsActionButtons";
import { deleteData } from "../../Services/deleteData";
import { postData } from "../../Services/postData";

export default function CoursesTable() {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState<CourseState>(new CourseState());
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedRow, setSelectedRow] = useState<CourseModel>(
    new CourseModel()
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [products, setProducts] = useState<ProductsModel[]>([]);

  /**
   *
   */
  useEffect(() => {
    const search = location.search.split("/");
    getCourses(state?.page, state?.perPage, search[3] ? search[3] : null);
    getProducts();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   * Fetches all available products
   */
  const getProducts = async () => {
    try {
      const response = await getData(endpoints.product.main);
      if (response?.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  /**
   *
   */
  const getCourses = (page: any, perPage: any, search?: any) => {
    let url = `${endpoints.courses}/paginated?page=${page}&perPage=${perPage}`;
    if (search) {
      url = `${endpoints.courses}/paginated?page=${page}&perPage=${perPage}&search=${search}`;
    }
    getData(url).then((res: AxiosResponse) => {
      setState({
        ...state,
        coursesPerPage: res.data.results,
        coursesNumber: res.data.numberOfResults,
        page: page,
        perPage: perPage,
        search: search || null,
      });
    });
  };

  /**
   *
   * @param {*} row
   */
  const onEdit = async (row: any) => {
    setSelectedRow(row);
    setOpenModal(true);
  };

  /**
   *
   * @param {*} row
   */
  const onDelete = async (row: any) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };

  /**
   * Sorts the courses based on the specified type.
   *
   * Sends a request to update the sort number of the courses.
   * After sorting, it refreshes the course list.
   *
   * @param {number} rowIndex - The index of the course to be sorted.
   * @param {"down" | "up"} [type] - The type of sort operation: "down" or "up".
   */

  const sort = (rowIndex: number, type?: "down" | "up") => {
    const body = {
      course1: state.coursesPerPage[rowIndex],
      course2:
        state.coursesPerPage[type == "down" ? rowIndex + 1 : rowIndex - 1],
    };
    postData(`${endpoints.courses}/update/sortNumber`, body).then(
      (res: AxiosResponse) => {
        getCourses(state.page, state.perPage, state.search);
      }
    );
  };
  const columns = [
    {
      name: "sortNumber",
      label: Vocabulary.sortNumber,
      options: {
        setCellHeaderProps: () => ({
          align: "center",
          width: 100,
        }),
        setCellProps: () => ({
          align: "center",
          width: 100,
        }),
        filter: false,
        sort: false,
        selectableRowsHeader: true,
        empty: true,
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "centers",
                justifyContent: "space-between",
              }}
            >
              <Button
                disabled={
                  rowIndex === state.coursesPerPage?.length - 1 ? true : false
                }
                color="inherit"
                //  style={{ padding: 0 }}
              >
                <KeyboardArrowDownIcon
                  style={{ cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    sort(rowIndex, "down");
                  }}
                />
              </Button>
              {state.coursesPerPage[rowIndex].sortNumber}
              <Button
                disabled={rowIndex === 0 ? true : false}
                color="inherit"
                style={{ padding: 0 }}
              >
                <KeyboardArrowUpIcon
                  style={{ cursor: "pointer" }}
                  onClick={(event) => {
                    event.stopPropagation();
                    sort(rowIndex, "up");
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
    {
      name: "name",
      label: Vocabulary.name,
    },
    {
      name: "productsIds",
      label: Vocabulary.products,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          const course = state.coursesPerPage[tableMeta.rowIndex];
          const products = course?.productsIds || [];

          if (products.length === 0) {
            return <span>-</span>;
          }

          return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", fontSize:"2rem" }}>
              {products.map((product: any, index: number) => (
                <Chip
                  key={`${product._id || product.name}-${index}`}
                  label={product.name || "Unknown"}
                  size="small"
           
                />
              ))}
            </div>
          );
        },
      },
    },
    {
      label: " ",
      name: "isDefault",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (dataIndex: any, rowIndex: any) => {
          return (
            <div
              style={{
                color: "white !important",
                float: "right",
              }}
            >
              <ToggleButtonGroup exclusive aria-label="text alignment">
                <Tooltip title={Vocabulary.edit}>
                  <ToggleButton
                    onClick={() => {
                      onEdit(state.coursesPerPage[rowIndex.rowIndex]);
                    }}
                    value="center"
                    aria-label="centered"
                  >
                    <Edit />
                  </ToggleButton>
                </Tooltip>
                {dataIndex ? null : (
                  <Tooltip title={Vocabulary.delete}>
                    <ToggleButton
                      onClick={(event) => {
                        event.stopPropagation();
                        onDelete(state.coursesPerPage[rowIndex.rowIndex]);
                      }}
                      value="center"
                      aria-label="centered"
                    >
                      <Delete />
                    </ToggleButton>
                  </Tooltip>
                )}
              </ToggleButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  /**
   *
   * @returns
   */
  const getTableOptions = () => {
    const responsive: "standard" | "vertical" | "simple" | undefined =
      "standard";
    return {
      selectableRows: "none" as any,
      viewColumns: false as any,
      responsive: responsive,
      rowsPerPage: state.perPage,
      rowsPerPageOptions: Config.rowsPerPageOptions,
      confirmFilters: true,
      filter: false,
      print: false,
      download: false,
      textLabels: {
        body: {
          noMatch: Vocabulary.noResultsFound,
        },
        pagination: {
          next: Vocabulary.nextPage,
          previous: Vocabulary.previousPage,
          rowsPerPage: Vocabulary.rowsPerPage,
          displayRows: Vocabulary.of,
        },
        toolbar: {
          search: Vocabulary.search,
          downloadCsv: Vocabulary.downloadCSV,
          print: Vocabulary.print,
        },
        selectedRows: {
          text: Vocabulary.rowsSelected,
          delete: Vocabulary.delete,
        },
      },
      count: state.coursesNumber,
      page: state.page,
      search: true,
      serverSide: true,
      sort: true,

      onChangePage: (page: any) => {
        navigate(
          `${localUrlEnum.courses}?page=${page + 1}?perPage=${state.perPage}`
        );
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows: number) => {
        navigate(`${localUrlEnum.courses}?page=${1}?perPage=${numberOfRows}`);
        window.scrollTo(0, 0);
      },
      onSearchChange: async (search: string | null) => {
        if (search) {
          navigate(
            `${localUrlEnum.courses}/${state.page}/${state.perPage}/${search}`
          );
        } else {
          setState({ ...state, search: null });
          navigate(
            `${localUrlEnum.courses}/${state.page}/${state.perPage}
            }`
          );
        }
      },
      onSearchClose: async () => {
        setState({ ...state, search: "" });
        navigate(
          `${localUrlEnum.courses}?page=${state.page + 1}?perPage=${
            state.perPage
          }`
        );
      },
      customToolbar: () => {
        return (
          <div style={{ margin: 5 }}>
            <Button
              variant="contained"
              onClick={() => {
                setSelectedRow(new CourseModel());
                setOpenModal(true);
              }}
            >
              <AddCircleIcon />
              {Vocabulary.add}
            </Button>
          </div>
        );
      },
    };
  };

  /**
   *
   */
  const handleDelete = () => {
    deleteData(`${endpoints.courses}/${selectedRow?._id}`).then(
      async (res: AxiosResponse) => {
        getCourses(state.page, state.perPage, state.search);
        setShowDeleteModal(false);
      }
    );
  };

  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTable
        title={Vocabulary.courses}
        data={state.coursesPerPage}
        columns={columns}
        options={getTableOptions()}
      />
      <CourseForm
        selectedRow={selectedRow}
        open={openModal}
        products={products}
        onClose={() => {
          setOpenModal(false);
          getCourses(state.page, state.perPage, state.search);
        }}
      />
      <GenericModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title={Vocabulary.confirmDeleteTitle}
        actions={
          <StandardActionButtons
            okAction={() => handleDelete()}
            cancelAction={() => setShowDeleteModal(false)}
            okText={Vocabulary.yes}
            cancelText={Vocabulary.no}
          />
        }
      >
        <div>{Vocabulary.confirmDeleteMessage}</div>
      </GenericModal>
    </div>
  );
}
